import React from 'react';

import classNames from 'classnames';

import { Input } from '@buildoutinc/blueprint-react/ui/Input';
import { Label } from '@buildoutinc/blueprint-react/ui/Label';
import { OTHER } from './selection';
import { RadioGroup } from '@buildoutinc/blueprint-react/ui/RadioGroup';

import type { QuestionOption } from './types';
import type { Selection } from './selection';

const PANEL_CLASS = 'ai-assistant-question-option d-flex gap-2 border rounded p-2 mb-0';

interface Props {
  disabled: boolean;
  options: QuestionOption[];
  other: string;
  selection: Selection;
  onChoose: (value: Selection) => void;
  onEnter: () => void;
  onOtherChange: (text: string) => void;
}

export function QuestionOptions({ disabled, options, other, selection, onChoose, onEnter, onOtherChange }: Props) {
  return (
    <RadioGroup value={selection} onValueChange={value => onChoose(value as Selection)}>
      {options.map((option, index) => (
        <Label
          className={classNames(PANEL_CLASS, { 'is-selected': selection === String(index) })}
          key={option.label}
          onClick={() => onChoose(String(index))}
        >
          <RadioGroup.Item disabled={disabled} value={String(index)} />
          <span>
            <span className="d-block fw-semibold">{option.label}</span>
            {option.description && <span className="d-block small text-muted">{option.description}</span>}
          </span>
        </Label>
      ))}

      <Label
        className={classNames(PANEL_CLASS, { 'is-selected': selection === OTHER })}
        onClick={() => onChoose(OTHER)}
      >
        <RadioGroup.Item disabled={disabled} value={OTHER} />
        <span className="flex-grow-1">
          <span className="d-block fw-semibold mb-1">Other</span>
          <Input
            disabled={disabled}
            placeholder="Type your own answer here"
            value={other}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => onOtherChange(event.target.value)}
            onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
              if (event.key === 'Enter') {
                event.preventDefault();
                onEnter();
              }
            }}
          />
        </span>
      </Label>
    </RadioGroup>
  );
}
